import {fork, put, takeEvery, all} from 'redux-saga/effects';
import config from '../../../config/config';
import {
    LogControllerDtoItemBoxOpenLogListRequest,
    LogControllerDtoItemBoxOpenLogListResponse,
    PerplayLogApi,
} from '../../models/src';

import {getErrorMessage} from '../../../utils/serverErrorCheck';
import {ITEM_BOX_LOG_LIST_REQUEST} from "../../constants/log/itemBoxLogConstants";
import {itemBoxLogList, setItemBoxLogPagination, setTotalCount} from "../../actions/log/itemBoxLogActions";


const api = new PerplayLogApi(config.API_CLIENT);

function* itemBoxLogListRequestSaga(payload) {
    console.assert(payload.callback, {
        message: 'callback이 설정되지 않았습니다.',
    });

    try {
        const requestData = new LogControllerDtoItemBoxOpenLogListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.beginDate = payload.beginDate;
        requestData.endDate = payload.endDate;
        requestData.accountNo = payload.account;
        console.log('requestData: ', requestData);

        const result = yield api.apiPerplayLogItemBoxOpenLogListPost({logControllerDtoItemBoxOpenLogListRequest: requestData}, () => {
        });
        const data = api.apiClient.deserialize(result, LogControllerDtoItemBoxOpenLogListResponse);

        if (data.resultCode !== 200) {
            throw new Error(getErrorMessage(data));
        }

        yield put(itemBoxLogList(data.list));
        yield put(setTotalCount(data.totalCount));
        yield put(setItemBoxLogPagination(
            payload.page,
            data.totalCount,
            payload.beginDate,
            payload.endDate,
            payload.searchCode,
            payload.searchString,
        ));
        payload.callback(data);
    } catch (e) {
        payload.error(e);
    }
}

function* itemBoxLogRootSaga() {
    yield all([
        takeEvery(ITEM_BOX_LOG_LIST_REQUEST, itemBoxLogListRequestSaga),
    ]);
}

const itemBoxLogSagas = [fork(itemBoxLogRootSaga)];

export default itemBoxLogSagas;
